export const NAME_MAX_LENGTH = 16;

/** Letters (any script), digits, space, underscore, dash and dot. */
const ALLOWED = /[^\p{L}\p{N} _.-]/gu;

/** Returns a safe display name, or `fallback` when nothing usable is left. */
export function sanitizeName(raw: unknown, fallback: string): string {
  if (typeof raw !== "string") return fallback;
  const cleaned = raw.replace(ALLOWED, "").replace(/\s+/g, " ").trim().slice(0, NAME_MAX_LENGTH).trim();
  return cleaned.length > 0 ? cleaned : fallback;
}
